import { Component, Inject, OnInit, AfterViewInit, OnDestroy  } from "@angular/core";
import { combineLatest, distinctUntilChanged, map } from 'rxjs';
import { DeviceDetectorService } from "ngx-device-detector";
import {_} from '../../../js/globals';
import { MySynchDataStore } from "../../data-stores/mysynch.datastore";
import { PerformanceMetricsService } from "../../services/performance-metrics.service";
import { PerformanceContextService } from "../../services/performance-context.service";
import { PerformanceContext } from "../../interfaces/mysynch.interfaces";

@Component({
    standalone: false,
    selector:"site-main-header",
    templateUrl: "../app/headers/site-main-header/site-main-header.view.html",
})
export class SiteMainHeader implements OnInit, AfterViewInit, OnDestroy  {
    private performanceContext: PerformanceContext | null = null;
    private currentActiveFarm: any = {name:""};
    private currentPageType:string = "";
    private _:any;
    private isMobile:boolean;
    nonSingleFarmPageTypes:string[] = ['MultiFarm','Admin'];

    private combinedFarmPageTypeSubscription:any;

    farmNameDisplay:string = "";
    
    constructor(@Inject('MySynchFactory') private MSF:any, 
                @Inject(MySynchDataStore) private mysynchDataStore:MySynchDataStore, 
                @Inject(DeviceDetectorService) private deviceDetector:DeviceDetectorService,
                @Inject(PerformanceMetricsService) private perfMetricSvc:PerformanceMetricsService,
                @Inject(PerformanceContextService) private perfContextSvc:PerformanceContextService) {
       this._ = _;
       this.isMobile = deviceDetector.isMobile();
    }

    private getFarmNameDisplay() {
        
             return this.getTruncatedFarmName(_.get(this.currentActiveFarm,'name',""));
        
    };
    private goToHelpPage(){
        this.MSF.loadPage('Help');
    }

    private goToMySynchLandingPage(){
        var homepage =  this.MSF.getUserHomepageStateName()
        this.MSF.loadPage(homepage);   
    }
    
    private getTruncatedFarmName(farmName){
        var truncatedFarmName = farmName;
        if(truncatedFarmName.length > 32){
            var ellipsis = "...";
            var farmNameFirstPart = truncatedFarmName.slice(0,14);
            var farmNameSecondPart = truncatedFarmName.slice(21,truncatedFarmName.length);
            if(farmNameSecondPart.length > 15){
                var extraTrimLength = farmNameSecondPart.length-15;
                farmNameSecondPart = farmNameSecondPart.slice(extraTrimLength,farmNameSecondPart.length);
            }
            truncatedFarmName = farmNameFirstPart+ellipsis+farmNameSecondPart;
        }  
        
        return truncatedFarmName;
    };

    ngOnDestroy(): void {
        if(this.combinedFarmPageTypeSubscription){
            this.combinedFarmPageTypeSubscription.unsubscribe();
        }
        this.performanceContext = null;
    }
    ngOnInit(){
        this.performanceContext = this.perfContextSvc.createPerformanceContext();
        this.perfMetricSvc.startTiming("Component:SiteMainHeader:Render");
      
        this.combinedFarmPageTypeSubscription = combineLatest([
            this.mysynchDataStore.currentActiveFarm,
            this.mysynchDataStore.currentPageType
        ]).pipe(
            map(([farm, pageType]) => {
                // Set the component properties
                if (!_.isUndefined(farm)) {
                    this.currentActiveFarm = farm;
                }
                if (!_.isUndefined(pageType) && !_.isEmpty(pageType)) {
                    this.currentPageType = _.cloneDeep(pageType);
                }
                
                // Calculate the farm name display value
                if (!_.isUndefined(farm) && !_.isUndefined(pageType) && !_.isEmpty(pageType)) {
                    return (!this._.includes(this.nonSingleFarmPageTypes, pageType)) 
                        ? this._.get(farm, 'name') 
                        : pageType != 'Admin' ? 'All My Farms' : 'Admin';
                }
                return this.farmNameDisplay; // Keep current value if data not ready
            }),
            distinctUntilChanged() // Only emit when the calculated result actually changes
        ).subscribe(newFarmNameDisplay => {
            this.farmNameDisplay = newFarmNameDisplay;
        });
    }
    ngAfterViewInit(){
          this.MSF.ready(()=>{
             this.perfMetricSvc.endTiming("component","Component:SiteMainHeader:Render", this.performanceContext);
          });
    }
}